export const environment = {
  'production': true,
  'proxy': 'https://proxy-dev.swaas.de',
  'mcp': 'https://mcp.swaas.de/',
  'MCP_CLIENTS_JSON': 'https://mcp-dev.swaas.de/clients.json',
  'clientID': null,
  'apiURL': 'null',
  'appVersion': require('../../package.json').version,
  'ngVersion': require('../../package.json').dependencies['@angular/pwa'],
  'appName' : 'GATES DEMO DASHBOARD'
}
